/** Login fields — keep empty; do not let the browser fill saved credentials. */
export const LOGIN_AUTOCOMPLETE = {
  form: { autoComplete: "off" },
  email: {
    autoComplete: "off",
    name: "login-email",
    "data-lpignore": "true",
    "data-1p-ignore": "true",
    "data-bwignore": "true",
    "data-form-type": "other",
  },
  password: {
    autoComplete: "new-password",
    name: "login-password",
    "data-lpignore": "true",
    "data-1p-ignore": "true",
    "data-bwignore": "true",
    "data-form-type": "other",
  },
};

export const SIGNUP_AUTOCOMPLETE = {
  form: { autoComplete: "off" },
  fullName: { autoComplete: "off", name: "signup-full-name" },
  email: { autoComplete: "off", name: "signup-email" },
  password: { autoComplete: "new-password", name: "signup-password" },
  phone: { autoComplete: "off", name: "signup-phone" },
};

export const NO_AUTOFILL_ATTRS = {
  autoComplete: "off",
  "data-lpignore": "true",
  "data-1p-ignore": "true",
  "data-bwignore": "true",
  "data-form-type": "other",
};

export const preventBrowserAutofillOnFocus = (event) => {
  const el = event.target;
  if (el && el.hasAttribute("readonly")) {
    el.removeAttribute("readonly");
  }
};

export const noAutofillEmailInputProps = {
  ...NO_AUTOFILL_ATTRS,
  autoComplete: "off",
  readOnly: true,
  onFocus: preventBrowserAutofillOnFocus,
};

export const noAutofillPasswordInputProps = {
  ...NO_AUTOFILL_ATTRS,
  autoComplete: "new-password",
  readOnly: true,
  onFocus: preventBrowserAutofillOnFocus,
};

export const signupSensitiveInputProps = {
  readOnly: true,
  onFocus: preventBrowserAutofillOnFocus,
};

export function stripAutofillFromInput(el) {
  if (!el || el.tagName !== "INPUT") return;
  if (el.dataset.autofillGuardBound) return;

  const type = (el.getAttribute("type") || "text").toLowerCase();
  const name = (el.getAttribute("name") || "").toLowerCase();
  const isPassword =
    type === "password" ||
    name.includes("password") ||
    name.includes("password_hash");
  const isEmail =
    type === "email" ||
    name === "email" ||
    name.includes("email") ||
    name === "username" ||
    name === "login-email";

  if (!isPassword && !isEmail) return;

  el.dataset.autofillGuardBound = "1";
  el.setAttribute("autocomplete", isPassword ? "new-password" : "off");
  el.setAttribute("data-lpignore", "true");
  el.setAttribute("data-1p-ignore", "true");
  el.setAttribute("data-bwignore", "true");
  el.setAttribute("data-form-type", "other");

  if (!el.hasAttribute("readonly")) {
    el.setAttribute("readonly", "readonly");
  }
  el.addEventListener("focus", preventBrowserAutofillOnFocus);
}
